import { useCallback } from 'react';
import { RowSelectionState, Updater } from '@tanstack/react-table';
import { getRowId } from '../utils';

interface UseGetSelectedRowOriginalDataProps<T> {
  data: T[];
}

export const useGetSelectedRowOriginalData = <T>({
  data,
}: UseGetSelectedRowOriginalDataProps<T>) =>
  useCallback(
    (
      updater: Updater<RowSelectionState>,
      currentState: RowSelectionState = {},
      currentSelectedRowsOriginalData: T[] = []
    ) => {
      const newSelection =
        typeof updater === 'function' ? updater(currentState) : updater;

      const selectedIds = Object.entries(newSelection)
        .filter(([_, value]) => value)
        .map(([key]) => key);

      const selectedFromCurrentData = (data || []).filter(row =>
        selectedIds.includes(getRowId(row))
      );

      const currentPageIds = new Set(selectedFromCurrentData.map(getRowId));

      const preservedOffPageRows = currentSelectedRowsOriginalData.filter(
        row =>
          selectedIds.includes(getRowId(row)) &&
          !currentPageIds.has(getRowId(row))
      );

      return [...selectedFromCurrentData, ...preservedOffPageRows];
    },
    [data]
  );
